export type CatalogoQueryFilterInputs = {
  selectedInstrumentTypes: string[];
  volatilityMin: string;
  volatilityMax: string;
  currentPvpMin: string;
  currentPvpMax: string;
  dy12mMin: string;
  dy12mMax: string;
  inadimplenciaMin: string;
  inadimplenciaMax: string;
  vacanciaMin: string;
  vacanciaMax: string;
  cashPressureMonths12mMin: string;
  cashPressureMonths12mMax: string;
  concentracaoTijoloMin: string;
  concentracaoTijoloMax: string;
  concentracaoPapelMin: string;
  concentracaoPapelMax: string;
  liquidezDiaria30dMin: string;
  liquidezDiaria30dMax: string;
  selicSensitivityScoreMin: string;
  selicSensitivityScoreMax: string;
  leverageIndexScoreMin: string;
  leverageIndexScoreMax: string;
  distanceTo12mHighMin: string;
  distanceTo12mHighMax: string;
  vpPerShareGrowth12mMin: string;
  vpPerShareGrowth12mMax: string;
  patrimonioMin: string;
  patrimonioMax: string;
  cotistasMin: string;
  cotistasMax: string;
  classificacao: string;
  segmento: string;
  cashTrendStatus: string;
};

const hasText = (value: string) => value.trim().length > 0;

export const buildCatalogoBaseQueryString = (selectedInstrumentTypes: string[]): string => {
  const params = new URLSearchParams();
  if (selectedInstrumentTypes.length > 0) {
    params.set('fundTypes', selectedInstrumentTypes.join(','));
  } else {
    params.set('excludeTreasury', '1');
  }
  return params.toString();
};

export const hasCatalogoAdvancedQueryFilters = (inputs: CatalogoQueryFilterInputs): boolean =>
  hasText(inputs.volatilityMin) ||
  hasText(inputs.volatilityMax) ||
  hasText(inputs.currentPvpMin) ||
  hasText(inputs.currentPvpMax) ||
  hasText(inputs.dy12mMin) ||
  hasText(inputs.dy12mMax) ||
  hasText(inputs.inadimplenciaMin) ||
  hasText(inputs.inadimplenciaMax) ||
  hasText(inputs.vacanciaMin) ||
  hasText(inputs.vacanciaMax) ||
  hasText(inputs.cashPressureMonths12mMin) ||
  hasText(inputs.cashPressureMonths12mMax) ||
  hasText(inputs.concentracaoTijoloMin) ||
  hasText(inputs.concentracaoTijoloMax) ||
  hasText(inputs.concentracaoPapelMin) ||
  hasText(inputs.concentracaoPapelMax) ||
  hasText(inputs.liquidezDiaria30dMin) ||
  hasText(inputs.liquidezDiaria30dMax) ||
  hasText(inputs.selicSensitivityScoreMin) ||
  hasText(inputs.selicSensitivityScoreMax) ||
  hasText(inputs.leverageIndexScoreMin) ||
  hasText(inputs.leverageIndexScoreMax) ||
  hasText(inputs.distanceTo12mHighMin) ||
  hasText(inputs.distanceTo12mHighMax) ||
  hasText(inputs.vpPerShareGrowth12mMin) ||
  hasText(inputs.vpPerShareGrowth12mMax) ||
  hasText(inputs.patrimonioMin) ||
  hasText(inputs.patrimonioMax) ||
  hasText(inputs.cotistasMin) ||
  hasText(inputs.cotistasMax) ||
  hasText(inputs.classificacao) ||
  hasText(inputs.segmento) ||
  hasText(inputs.cashTrendStatus);

export const buildCatalogoFilterQueryString = (inputs: CatalogoQueryFilterInputs): string => {
  const params = new URLSearchParams();
  const appendValue = (key: string, value: string) => {
    const normalized = value.trim();
    if (!normalized) return;
    params.set(key, normalized);
  };

  if (inputs.selectedInstrumentTypes.length > 0) {
    params.set('fundTypes', inputs.selectedInstrumentTypes.join(','));
  }
  appendValue('volatilityMin', inputs.volatilityMin);
  appendValue('volatilityMax', inputs.volatilityMax);
  appendValue('currentPvpMin', inputs.currentPvpMin);
  appendValue('currentPvpMax', inputs.currentPvpMax);
  appendValue('dy12mMin', inputs.dy12mMin);
  appendValue('dy12mMax', inputs.dy12mMax);
  appendValue('inadimplenciaMin', inputs.inadimplenciaMin);
  appendValue('inadimplenciaMax', inputs.inadimplenciaMax);
  appendValue('vacanciaMin', inputs.vacanciaMin);
  appendValue('vacanciaMax', inputs.vacanciaMax);
  appendValue('cashPressureMonths12mMin', inputs.cashPressureMonths12mMin);
  appendValue('cashPressureMonths12mMax', inputs.cashPressureMonths12mMax);
  appendValue('concentracaoTijoloMin', inputs.concentracaoTijoloMin);
  appendValue('concentracaoTijoloMax', inputs.concentracaoTijoloMax);
  appendValue('concentracaoPapelMin', inputs.concentracaoPapelMin);
  appendValue('concentracaoPapelMax', inputs.concentracaoPapelMax);
  appendValue('liquidezDiaria30dMin', inputs.liquidezDiaria30dMin);
  appendValue('liquidezDiaria30dMax', inputs.liquidezDiaria30dMax);
  appendValue('selicSensitivityScoreMin', inputs.selicSensitivityScoreMin);
  appendValue('selicSensitivityScoreMax', inputs.selicSensitivityScoreMax);
  appendValue('leverageIndexScoreMin', inputs.leverageIndexScoreMin);
  appendValue('leverageIndexScoreMax', inputs.leverageIndexScoreMax);
  appendValue('distanceTo12mHighMin', inputs.distanceTo12mHighMin);
  appendValue('distanceTo12mHighMax', inputs.distanceTo12mHighMax);
  appendValue('vpPerShareGrowth12mMin', inputs.vpPerShareGrowth12mMin);
  appendValue('vpPerShareGrowth12mMax', inputs.vpPerShareGrowth12mMax);
  appendValue('patrimonioMin', inputs.patrimonioMin);
  appendValue('patrimonioMax', inputs.patrimonioMax);
  appendValue('cotistasMin', inputs.cotistasMin);
  appendValue('cotistasMax', inputs.cotistasMax);
  appendValue('classificacao', inputs.classificacao);
  appendValue('segmento', inputs.segmento);
  appendValue('cashTrendStatus', inputs.cashTrendStatus);

  return params.toString();
};
